import React from 'react';
import { Carousel, Col, Row } from 'react-bootstrap';
import ReactPlayer from 'react-player';
import './secciones.css'

const Videos = ({ videos }) => {
    
    if(!videos || videos.length < 1) return null;
    return (
        <Row>
            <Col md={7} className="mx-auto mb-5">
                <Carousel className="slider-flechas">
                    {videos && videos.length > 0 && videos.map((video, i) =>
                        <Carousel.Item key={i} className="player-wrapper">
                            <ReactPlayer width="100%" height="100%" className="hyundai-video-player" url={video.Multimedia} />
                        </Carousel.Item>
                    )}
                </Carousel>
            </Col>
        </Row>
    );
}

export default Videos;